import { map, retry } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiRoutesV2, getRouteUrlByAccountGroupId } from '../common/routes';

export interface GetVbcHostnameResponse {
  host: string;
}

@Injectable()
export class ProApiService {
  constructor(private http: HttpClient) {}

  getVbcHostname(accountGroupId: string): Observable<string> {
    const url = getRouteUrlByAccountGroupId(ApiRoutesV2.vbcHostGet, accountGroupId);
    return this.http.get<GetVbcHostnameResponse>(url).pipe(
      retry(2),
      map((rs) => rs.host),
    );
  }
}
